import './CardAction.8c82bdccf83092be5677b9c196b77eec.css';
export default {"cardAction":"_cardAction_1r5uy_1","button":"_button_1r5uy_1","ignoreResponsive":"_ignoreResponsive_1r5uy_1","content":"_content_1r5uy_1","icon":"_icon_1r5uy_1"};